module.exports = __webpack_public_path__ + "static/media/icon-copy.d09b7d2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-copy.svg
// module id = 951
// module chunks = 0